export const getTranslationsByLanguageSchema = {
  params: {
    type: "object",
    properties: {
      languageCode: { type: "string" },
    },
    required: ["languageCode"],
  },
};

export const getAllTranslationsSchema = {
  querystring: {
    type: "object",
    properties: {
      page: { type: "integer", minimum: 1 },
      limit: { type: "integer", minimum: 1 },
      languageCode: { type: "string" },
    },
  },
};

export const getTranslationByKeySchema = {
  params: {
    type: "object",
    properties: {
      key: { type: "string" },
    },
    required: ["key"],
  },
};

export const createTranslationSchema = {
  body: {
    type: "object",
    properties: {
      translationKey: { type: "string" },
      translations: {
        type: "array",
        items: {
          type: "object",
          properties: {
            languageCode: { type: "string" },
            value: { type: "string", minLength: 1 },
          },
          required: ["languageCode", "value"],
        },
        minItems: 1,
      },
    },
    required: ["translationKey", "translations"],
  },
};

export const importTranslationsSchema = {
  body: {
    type: "object",
    properties: {
      file: {
        type: "object",
        properties: {
          data: { type: "string" },
          name: { type: "string" },
          type: {
            type: "string",
            enum: [
              "text/csv",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/vnd.ms-excel",
            ],
          },
        },
        required: ["data", "name", "type"],
      },
    },
    required: ["file"],
  },
};

export const exportTranslationsSchema = {
  querystring: {
    format: { type: "string", enum: ["csv", "xlsx"], default: "csv" },
  },
};

export const updateTranslationSchema = {
  body: {
    type: "object",
    properties: {
      updates: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: { type: "integer" },
            value: { type: "string", minLength: 1 },
          },
          required: ["id", "value"],
        },
        minItems: 1,
      },
    },
    required: ["updates"],
  },
};

export const deleteTranslationSchema = {
  body: {
    type: "object",
    properties: {
      ids: {
        type: "array",
        items: { type: "integer" },
        minItems: 1,
      },
    },
    required: ["ids"],
  },
};

export const getTranslationVersionHistorySchema = {
  querystring: {
    type: "object",
    properties: {
      page: { type: "integer", minimum: 1 },
      limit: { type: "integer", minimum: 1 },
    },
  },
};

export const web_createTranslationSchema = (languages) => {
  const properties = {
    translationKey: {
      type: "string",
      minLength: 1,
      pattern: "^[a-z0-9_.]+$",
    },
  };

  languages.forEach((lang) => {
    properties[lang] = { type: ["string", "null"], minLength: 1 };
  });

  return {
    type: "object",
    properties,
    required: ["translationKey"],
    errorMessage: {
      properties: {
        translationKey:
          "Translation key can only contain lowercase letters, numbers, underscores, and dots",
      },
    },
  };
};
